<template>
  <div class="expandable-content">
    <div
      ref="contentRef"
      class="content-wrapper"
      :class="{ 'collapsed': isCollapsed }"
      :style="{lineHeight: `${lineHeight}px`, maxHeight: contentMaxHeight, overflow: overflow}"
      v-html="content"
    />
    <div class="toggle-button-container">
      <div
        v-if="shouldShowMore"
        class="toggle-button"
        @click="toggleExpand"
      >
        {{ isExpanded ? showLessText : showMoreText }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ExpandableText',
  props: {
    content: {
      type: String,
      required: true,
    },
    maxLines: {
      type: Number,
      default: 4,
    },
    lineHeight: {
      type: Number,
      default: 18,
    },
    showMoreText: {
      type: String,
      default: '查看更多',
    },
    showLessText: {
      type: String,
      default: '收起',
    },
  },
  data() {
    return {
      isExpanded: false,
      shouldShowMore: false,
    };
  },
  computed: {
    contentMaxHeight() {
      return this.isCollapsed ? `${this.maxLines * this.lineHeight}px` : '';
    },
    isCollapsed() {
      return !this.isExpanded && this.shouldShowMore;
    },
    overflow() {
      return this.isCollapsed ? 'hidden' : 'visible';
    },
  },
  watch: {
    content() {
      this.$nextTick(() => {
        this.isExpanded = false;
        this.checkContentHeight();
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.checkContentHeight();
    });
  },
  methods: {
    checkContentHeight() {
      if (!this.$refs.contentRef) {
        return;
      }
      const element = this.$refs.contentRef;
      // 临时移除折叠样式测量真是高度
      element.classList.remove('collapsed');
      // 获取行高
      const lineHeight = parseInt(window.getComputedStyle(element).lineHeight, 10);
      const maxHeight = lineHeight * this.maxLines;

      // 检查内容是否超过指定行数
      this.shouldShowMore = element.scrollHeight > maxHeight;
      // 如果不需要展开，确保移除折叠样式
      if (!this.shouldShowMore) {
        this.isExpanded = false;
      }
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>

<style lang="less" scoped>
.expandable-content {
  width: 100%;

  .content-wrapper {
    margin-left: 4px;
    margin-bottom: 12px;
    font-size: 12px;
    color: #242729;
    opacity: 0.6;
    // line-height: 18px;
    word-wrap: break-word;
    overflow: hidden;
    transition:all 0.3s ease;
  }

  // .collapsed {
    // max-height: 72px;
    // overflow: hidden;
  // }

  /deep/ p {
    margin: 0 0 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  /deep/ a {
    color: #1890ff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .toggle-button-container {
    display: flex;
    justify-content: center;
    align-items: center;

    .toggle-button {
      width: 80px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 12px;
      user-select: none;
      background: #e1e6eb;
      border-radius: 12px;
      color: #242729;
      opacity: 0.6;
    }
  }
}
</style>
